export default __webpack_public_path__ + "static/unit1-7dfd22da1ece5c22d016562234c5f0eb.jpeg";